import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const isInternal = () => {
  try {
    return localStorage.getItem("ruta360_interno") === "1";
  } catch {
    return false;
  }
};

const getVid = () => {
  try {
    let v = localStorage.getItem("ruta360_vid");
    if (!v) {
      v =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem("ruta360_vid", v);
    }
    return v;
  } catch {
    return "";
  }
};

const computeFuente = () => {
  try {
    const url = new URL(window.location.href);
    const utm = (url.searchParams.get("utm_source") || "").toLowerCase();
    const ref = (document.referrer || "").toLowerCase();
    if (
      url.searchParams.get("fbclid") ||
      ["facebook", "fb", "instagram", "ig", "meta"].some((s) => utm.includes(s)) ||
      ref.includes("facebook.com") ||
      ref.includes("instagram.com")
    ) {
      return "Facebook/Instagram";
    }
    if (url.searchParams.get("gclid") || ref.includes("google.")) return "Google";
    if (ref.includes("tiktok") || utm.includes("tiktok")) return "TikTok";
    if (ref.includes("whatsapp") || ref.includes("wa.me") || utm.includes("whatsapp") || utm.includes("wa.me"))
      return "WhatsApp";
    if (ref) {
      const host = new URL(ref).hostname;
      if (host && host !== window.location.hostname) return "Otro sitio";
    }
    return "Directo";
  } catch {
    return "Directo";
  }
};

const getFuente = () => {
  try {
    let f = sessionStorage.getItem("ruta360_fuente");
    if (!f) {
      f = computeFuente();
      sessionStorage.setItem("ruta360_fuente", f);
    }
    return f;
  } catch {
    return "Directo";
  }
};

const getDispositivo = () => {
  const mobileUA = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent || "");
  return window.innerWidth < 768 || mobileUA ? "Celular" : "Computadora";
};

export const trackVisit = (path, tipo = "visita") => {
  try {
    const p = path || window.location.pathname;
    if (p.startsWith("/admin")) return;
    axios
      .post(`${API}/track/visit`, {
        path: p,
        fuente: getFuente(),
        dispositivo: getDispositivo(),
        tipo,
        vid: getVid(),
        interno: isInternal(),
      })
      .catch(() => {});
  } catch {
    /* silencioso */
  }
};

export const trackCartAdd = () => trackVisit(window.location.pathname, "carrito");
